import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// No persisted/cached permission: an unavailable API or a new record fails closed.
export function useTaskWorkflowWritesEnabled(scope: string | null | undefined): boolean {
  const [result, setResult] = useState<{scope: string; enabled: boolean} | null>(null);
  useEffect(() => {
    let current = true;
    setResult(null);
    if (scope) {
      api.get<{writes_enabled: boolean}>('/task-workflow/capabilities', {retry: false})
        .then(value => { if (current) setResult({scope, enabled: value?.writes_enabled === true}); })
        .catch(() => { if (current) setResult(null); });
    }
    return () => { current = false; };
  }, [scope]);
  return Boolean(scope && result?.scope === scope && result.enabled);
}
